import { useRecoilValue } from "recoil"
import { coinPriceState } from "../coins"

export const useCoinPrice = (mint: string | undefined) => {
    const price = useRecoilValue(coinPriceState(mint))
    return price
}